import React from 'react';
import type { Node } from 'ricos-schema';
import { Decoration_Type } from 'ricos-schema';
import type { NodeViewDecorator, UnderlineDecoration } from 'ricos-types';

const decorator = (element: JSX.Element, underlineDecoration: UnderlineDecoration) => {
  const { underlineData } = underlineDecoration;
  const isUnderline = typeof underlineData === 'undefined' || underlineData;
  return (
    <u key={element.key} style={{ textDecoration: isUnderline ? 'underline' : 'none' }}>
      {element}
    </u>
  );
};

const UnderlineDecorator: NodeViewDecorator<JSX.Element> = {
  rule: (node: Node) =>
    !!node.textData?.decorations?.some(({ type }) => type === Decoration_Type.UNDERLINE),
  decorate: ({ element, node }) => {
    const underlineDecoration = node.textData?.decorations?.find(
      ({ type }) => type === Decoration_Type.UNDERLINE
    ) as UnderlineDecoration;
    return decorator(element as JSX.Element, underlineDecoration);
  },
  priority: 2,
};

export default UnderlineDecorator;
